import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgNoData(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.698 45.552 29 36.107v14h-8v-2.47c0-.761.252-1.492.698-2.085Z" fill="#42A486" />
      <path
        d="M28.367 35.617a.8.8 0 0 1 1.433.49v14a.8.8 0 0 1-.8.8h-8a.8.8 0 0 1-.8-.8v-2.47c0-.937.31-1.837.86-2.566l.005-.008 7.302-9.446ZM21.8 49.307h6.4V38.448l-5.869 7.593a2.667 2.667 0 0 0-.531 1.596v1.67Z"
        fill="#0F172A"
      />
      <path d="M97.302 45.552 90 36.107v14h8v-2.47c0-.761-.251-1.492-.698-2.085Z" fill="#42A486" />
      <path
        d="M97.2 47.637c0-.581-.19-1.141-.531-1.596l-5.87-7.593v10.859H97.2v-1.67Zm1.6 2.47a.8.8 0 0 1-.8.8h-8a.8.8 0 0 1-.8-.8v-14a.8.8 0 0 1 1.433-.49l7.302 9.446.005.008c.55.729.86 1.629.86 2.566v2.47Z"
        fill="#0F172A"
      />
      <path d="M90 36.107H29v54h61v-54Z" fill="#80CCB5" />
      <path
        d="M90 35.307a.8.8 0 0 1 .8.8v54a.8.8 0 0 1-.8.8H29a.8.8 0 0 1-.8-.8v-54a.8.8 0 0 1 .8-.8h61Zm-60.2 54h59.4v-52.4H29.8v52.4Z"
        fill="#0F172A"
      />
      <path d="M72.2 48.107v-2a.8.8 0 1 1 1.6 0v2a.8.8 0 1 1-1.6 0Z" fill="#0F172A" />
      <path
        d="M95.24 44.107H23.76c-1.524 0-2.76 1.25-2.76 2.793v50.413c0 1.543 1.236 2.794 2.76 2.794h71.48c1.524 0 2.76-1.251 2.76-2.794V46.9c0-1.543-1.236-2.793-2.76-2.793Z"
        fill="#CAE8DF"
      />
      <path
        d="M69.23 53.107H50.77c-1.53 0-2.77 1.22-2.77 2.727v4.545c0 1.507 1.24 2.728 2.77 2.728h18.46c1.53 0 2.77-1.221 2.77-2.728v-4.545c0-1.506-1.24-2.727-2.77-2.727Z"
        fill="#42A486"
      />
      <path
        d="M72.495 41.563a.8.8 0 0 1 .958.601c.112.49.247.968.403 1.43a.8.8 0 0 1-1.516.511 16.443 16.443 0 0 1-.447-1.584.8.8 0 0 1 .602-.958Zm-.732-5.593a.8.8 0 0 1 1.57.31c-.194.98-.272 1.968-.25 2.942a.8.8 0 0 1-1.6.037 15.195 15.195 0 0 1 .28-3.29Zm2.751-5.977a.8.8 0 1 1 1.254.993 12.29 12.29 0 0 0-1.534 2.498.8.8 0 0 1-1.454-.668 13.896 13.896 0 0 1 1.734-2.823Zm5.049-4.16a.8.8 0 0 1 .767 1.404 16.265 16.265 0 0 0-2.482 1.653.8.8 0 1 1-1.009-1.242 17.86 17.86 0 0 1 2.724-1.815Zm6.047-2.263a.8.8 0 0 1 .375 1.556 26.29 26.29 0 0 0-2.913.877.8.8 0 0 1-.553-1.501 27.882 27.882 0 0 1 3.09-.932Zm4.734-.803a.801.801 0 0 1 .17 1.592c-.522.056-1.03.12-1.523.192a.8.8 0 0 1-.232-1.583 40.959 40.959 0 0 1 1.585-.2Z"
        fill="#0F172A"
      />
      <path
        d="M98.615 21.991s-4.571-3.02-5.41-1.845c-.839 1.174.839 2.642 1.594 2.642.67-.042 3.816-.797 3.816-.797Z"
        fill="#A6DBCB"
      />
      <path
        d="M98.615 22.117s-3.02 4.571-4.278 3.816c-1.258-.712-.251-2.767.42-3.019.713-.294 3.858-.797 3.858-.797Z"
        fill="#A6DBCB"
      />
      <path
        d="M96.207 23.518c1.542-.317 2.706-.997 2.599-1.52-.108-.52-1.445-.687-2.988-.37-1.543.318-2.706.998-2.599 1.52.107.522 1.445.688 2.988.37ZM97.2 57.86V46.9c0-1.112-.884-1.994-1.96-1.994H23.76c-1.076 0-1.96.882-1.96 1.995v50.412c0 1.112.884 1.994 1.96 1.994h12.857a.8.8 0 1 1 0 1.599H23.761c-1.979 0-3.56-1.615-3.56-3.593V46.9c0-1.978 1.581-3.593 3.56-3.593h71.478c1.978 0 3.56 1.615 3.56 3.593v10.96a.8.8 0 1 1-1.599 0Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgNoData)
